module.exports = __webpack_public_path__ + "static/media/compass_blue.92c9f58f.png";